module.exports = __webpack_public_path__ + "static/assets/d9d0ceb19a56eef016a825e06ef69b5f.svg";